<template>
  <div class="setPhoto">
    <el-form
      style="margin-top:25px;"
      :model="ruleForm2"
      :rules="rules2"
      ref="ruleForm2"
      class="demo-ruleForm"
      v-show="revisionBox"
    >
      <el-form-item label="手机号码：" prop="photo">
        <el-input type="text" v-model="ruleForm2.photo" placeholder="请输入您的手机号"></el-input>
      </el-form-item>
      <el-form-item label="验证码：" prop="code">
        <el-input type="text" v-model="ruleForm2.code" placeholder="请输入验证码"></el-input>
        <span v-show="sendAuthCode" class="code" @click="getCode">获取验证码</span>
        <span v-show="!sendAuthCode" class="code">{{auth_time}}秒后重新获取</span>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :disabled="isSubmitIng" @click="submitForm('ruleForm2')">提交</el-button>
      </el-form-item>
    </el-form>
    <div class="setSuccessd textAign ft16" v-show="successBox">
      <img src="../../../../../assets/images/safety/succeed_icon.png">
      <br>修改成功
    </div>
    <div class="setSuccessd textAign ft16" v-show="defeatedBox">
      <img src="../../../../../assets/images/register/fail_icon.png">
      <br>修改失败
    </div>
  </div>
</template>
<script>
import BaseApi from "@lib/baseApi.js";
import {mapMutations} from "vuex";
export default {
  props: {
    message: {}
  },
  data() {
    var validatePass = (rule, value, callback) => {
      var photoReg = /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/;
      if (photoReg.test(value)) {
        var params = {
          account: value
        };
        BaseApi.createRpcToken("/user/checkAccount", params)
          .then(data => {
            console.log(data);
            if (data.datas.code == 3001) {
              this.isExist = true;
            } else if (data.datas.code == 3007) {
              this.isExist = false;
            }
            if (this.message.mobile != "") {
              if (value === "") {
                callback(new Error("请输入手机号码"));
              } else if (!photoReg.test(value)) {
                callback(new Error("您输入的不是手机号，请重新输入"));
              } else if (this.message.mobile == value) {
                callback(new Error("您绑定的手机号和当前手机号一致"));
              } else if (this.isExist == true) {
                callback(new Error("该用户被占用"));
              } else if (this.isExist == false) {
                callback();
              } else {
                callback();
              }
            } else {
              if (value === "") {
                callback(new Error("请输入手机号码"));
              } else if (!photoReg.test(value)) {
                callback(new Error("您输入的不是手机号，请重新输入"));
              } else if (this.isExist == true) {
                callback(new Error("该用户被占用"));
              } else if (this.isExist == false) {
                callback();
              } else {
                callback();
              }
            }
          })
          .catch(function(e) {
            errorLog(e);
          });
      } else {
        if (!photoReg.test(value)) {
          callback(new Error("您输入的不是手机号，请重新输入"));
        }
      }
    };
    return {
      ruleForm2: {
        photo: "",
        code: ""
      },
      // 是否正在提交
      isSubmitIng: false,
      rules2: {
        photo: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
          {
            pattern: /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/,
            message: "您输入的不是手机号，请重新输入",
            trigger: "blur"
          }
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      },
      sendAuthCode: true,
      auth_time: 0,
      revisionBox: true,
      defeatedBox: false,
      successBox: false,
      isExist: false
    };
  },
  methods: {
    ...mapMutations(['setUpdateUserState']),
    submitForm(formName) {
      this.isSubmitIng = true;
      this.$refs[formName].validate(valid => {
        if (valid) {
          var params = {
            account: this.ruleForm2.photo
          };
          BaseApi.createRpcToken("/user/checkAccount", params)
            .then(
              data => {
                if (data.datas.code != 3001) {
                  var queryStr = {
                    mobile: this.ruleForm2.photo,
                    mobileCode: this.ruleForm2.code
                  };
                  BaseApi.createRpcToken(
                    "/user/setMobile",
                    queryStr,
                    "post"
                  ).then(
                    data => {
                      if (data.code == "200") {
                        this.revisionBox = false;
                        this.successBox = true;
                        setTimeout(() => {
                          this.$emit("closeDialog", false);
                          this.revisionBox = true;
                          this.successBox = false;
                          window.location.reload();
                          this.$refs[formName].resetFields();
                          this.sendAuthCode = true;
                          this.$emit("init");
                          this.isSubmitIng = false;
                        }, 2000);
                      }
                    },
                    data => {
                      // this.revisionBox = false;
                      // this.defeatedBox = true;
                      // setTimeout(() => {
                      //   this.revisionBox = true;
                      //   this.sendAuthCode = true;
                      //   this.defeatedBox = false;
                      //   this.isSubmitIng = false;
                      //   this.init();
                      // }, 2000);
                    }
                  );
                } else {
                  this.isSubmitIng = false;
                }
              },
              data => {
                this.isSubmitIng = false;
              }
            )
            .catch(function(e) {
              errorLog(e);
            });
        } else {
          this.isSubmitIng = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    getCode() {
      var photoReg = /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/;
      if (this.ruleForm2.photo != "") {
        if (!photoReg.test(this.ruleForm2.photo)) {
          this.$refs.ruleForm2.validateField("photo");
          return;
        }
        if (this.isExist == true) {
          return;
        }
        var queryStr = {
          mobile: this.ruleForm2.photo
        };
        BaseApi.createRpcToken("/common/getBindingMobileCode", queryStr)
          .then(
            data => {
              console.log(data);
            },
            data => {
              console.log(data);
            }
          )
          .catch(function(e) {
            errorLog(e);
          });
        this.sendAuthCode = false;
        this.auth_time = 60;
        var auth_timetimers = setInterval(() => {
          this.auth_time--;
          if (this.auth_time <= 0) {
            this.sendAuthCode = true;
            clearInterval(auth_timetimers);
          }
        }, 1000);
      } else {
        this.$refs.ruleForm2.validateField("photo");
      }
    }
  },
  created() {}
};
</script>
<style lang="scss">
.setPhoto {
  width: 100%;
  height: 210px;
  padding: 0 33px;
  box-sizing: border-box;
  display: table;
  .el-form {
    .el-input {
      float: left;
    }
    .el-input__inner {
      width: 300px;
      height: 30px;
      border-radius: 0;
    }
    .el-form-item__content {
      float: left;
      margin: 0 !important;
      .el-button--primary {
        height: 40px;
        width: 160px;
        margin-top: 20px;
        margin-left: 100px;
        background: #D81212;
        border: none;
      }
      .el-button--primary:hover {
        background: #a5303d;
      }
    }
    .el-form-item__label {
      width: 81px !important;
      float: left;
      margin: 0;
      font-family: "PingFangSC-Medium";
      font-size: 14px;
      color: #969696;
      text-align: right;
      padding-right: 0;
    }
    .el-form-item:nth-child(2) {
      .el-input__inner {
        width: 180px;
      }
      .el-input {
        width: 180px;
      }
    }
  }
  .setSuccessd {
    width: calc(100% - 78px);
    position: absolute;
    height: 100px;
    top: 50%;
    margin-top: -50px;
    text-align: center;
    color: #505050;
    padding: 0 39px;
    box-sizing: border-box;
    font-family: "PingFangSC-Medium";
  }
  .code {
    display: inline-block;
    width: 108px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    border: 1px solid #e88078;
    color: #e88078;
    margin-left: 10px;
    cursor: pointer;
  }
}
</style>


